<ngx-spinner
  [bdColor]="bdColor"
  template="<img src='https://kleksi.com/img/kleksi_logo_anim.png' width='{{ imgWidth }}'/>"
  [fullScreen]="fullscreen"
>
  <ng-content> </ng-content>
</ngx-spinner>
